let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1RIZj")).then(() => parcelRequire('79vH0'));